<template>
    <div>
        <div class="title">
            <h1> RESUME/CV </h1>
            <p> CLICK
                <a @click="download">HERE</a>
                FOR A COPY OF MY CURRENT RESUME (Updated April 2026) <br>

            </p>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="photo">
                        <img src="../assets/facephoto.webp">
                    </div>
                </el-col>
                <el-col :span="14">
                    <div class="content-text">
                        <h2>EDUCATION </h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                    &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                    2019-2024 . Ph.D, Design science, College of Computer Science and Technology, Zhejiang University (ZJU)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2016 . Student exchange program, Engineering Product Development (EPD), Singapore University of Technology and Design (SUTD) <br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2015-2019 . BA, Industry design, College of Computer Science and Technology, Zhejiang University (ZJU) <br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <h2>HONORS & AWARDS </h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2025 . Gold Award (Provincial), China International College Students' Innovation Competition (formerly "Internet+") (Project Leader)<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2024 . Outstanding Graduate of Zhejiang University (university level)<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2022-2023 . Outstanding Graduate Student of College of Computer Science and Technology, Zhejiang University  <br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2021-2022 . Social practice advanced individual of College of Computer Science and Technology, Zhejiang University  <br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2020-2021 . Outstanding Graduate Student of College of Computer Science and Technology, Zhejiang University  <br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2019 . PhD Freshman Scholarship of College of Computer Science and Technology, Zhejiang University<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2019 . Outstanding Graduation Thesis for Undergraduates of Computer Science and Technology, Zhejiang University<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . National First Prize of the 4th China Postgraduate Mobile Application Design Innovation Competition<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . National Third Prize of China University Mobile Application Innovation Contest<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . Outstanding Undergraduate Student & Academic Second Class Scholarship of College of Computer Science and Technology, Zhejiang University<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                        <el-row>
                            <el-col :span="2">
                                <div class="bullet">
                                    &#8226;
                                </div>
                            </el-col>
                            <el-col :span="22">
                                <div>
                                    2017 . Outstanding Undergraduate Student & Academic Second Class Scholarship of College of Computer Science and Technology, Zhejiang University<br>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                        <h2>EXCHANGE EXPERIENCE </h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2019 . Collective Action of Mobility Program of University Students in Asia (CAMPUS Asia),Chiba University, Japan
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . Collective Action of Mobility Program of University Students in Asia (CAMPUS Asia),Yonsei University, Korea
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2016 . Singapore University of Technology and Design (SUTD) Exchange Program
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <h2>PROJECT PRACTICE </h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2020.01 - 2022.09 . 【National Key R&amp;D Program (sub-project)】Research on material models of complex cultural relics (2019YFC1521103). As a core member, I proposed a texture-mapping-based solution to defects in 3D scanned models of semi-transparent cultural relics, built subsurface-scattering (3S) material models for multiple jade types, developed a batch rendering plugin, improved visual realism of digitized semi-transparent relics, and increased rendering efficiency for museum digitization.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2025.01 - 2026.12 . 【Jianbing-Lingyan Program】R&amp;D and application of a large live-streaming product-selection center for toy products (2025C03009). As a core member, I led requirements analysis and system architecture design, and addressed challenges such as intelligent toy-category matching and multi-terminal data collaboration, supporting the project's transition from traditional to digital, intelligent operations.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2020.01 - 2022.01 . 【Zhejiang Provincial Basic Public Welfare Research Program】Research and rehabilitation application for children with dyslexia (LGF20F020019). As a core member, I was responsible for literacy assessment, data collection, rehabilitation protocol design and experiments, contributing to a scientific, actionable early intervention and rehabilitation system for developmental dyslexia.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2023.10 - 2025.12 . 【Zhejiang Cultural and Tourism S&amp;T Innovation Demonstration Project】Digitalization of Jiashan cultural resources and public cultural-tourism cloud services. As a core member, based on Jiashan's cultural-tourism resource digitization initiative, I helped develop the Jiashan cultural-tourism service cloud platform, supporting retrieval, sharing and display of resources, as well as transportation, routes, weather, homestay booking, cultural event ticketing, and related services.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2021.09 - 2023.12 . 【Industry collaboration】AR-assisted routing system and integrated data management platform. As a major participant, I contributed to designing and developing an AR-assisted cable routing system and data management middleware for a leading domestic aviation industry group, enabling operators to complete wiring design verification, routing operations, and inspection for large aircraft more efficiently.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="section-heading">
                            <h2>RESEARCH </h2>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://scholar.google.com/citations?hl=en&user=8JnbAC4AAAAJ"
                            >
                                <input class="detailBTN" type="button" value="Google Scholar">
                            </a>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        <b>Gong, Q.*</b>, Chen, C., Wang, K., Li, C., Qin, Y., Qiao, X., Zou, N. (2026). From Service Dogs to Robots: A Bio-inspired Framework for Intuitive Intent Prediction in Mixed Reality. <i>International Journal of Human–Computer Interaction</i>, 1–19. (TOP journal, SCI &amp; CCF-B, Q1, first author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        <b>Gong, Q.*</b>, Wang, Z., Chen, Y., Zou, N. (2024). ‘Rhetoric’ in the design process: The role of prop-based virtual reality storytelling in user-centred product conceptual design. <i>Design Journal</i>, 27(6). (AHCI, first author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        <b>Gong, Q.*</b>, Zou, N., Yang, W. et al. (2024). User experience model and design strategies for virtual reality-based cultural heritage exhibition. <i>Virtual Reality</i>, 28(2). (SCI, Q1, first author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., <b>Gong, Q.*</b>, Li, X., Zhao, Z., Chai, C. (2023). Context Connection: A Product Creative Design Method for Integrating Design Materials and Design Resources. <i>Creativity Research Journal</i>, 36(4). (SSCI, Q1, student first author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., <b>Gong, Q.*</b>, Chai, Q., &amp; Chai, C. (2023). The role of virtual reality technology in conceptual design: Positioning, applications, and value. <i>Digital Creativity</i>, 34(1). (AHCI, student first author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., <b>Gong, Q.*</b>, Zhou, J., Chen, P., Kong, W., &amp; Chai, C. (2021). Value-based model of user interaction design for virtual museum. <i>CCF Transactions on Pervasive Computing and Interaction</i>, 3(2), 112–128. (SCI &amp; CCF-B, student first author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., Chen, Y., Chen, P., <b>Gong, Q.*</b> (2025). Research on multimodal interaction system based on cognitive style in virtual historical and cultural scenes. <i>Design and Artificial Intelligence</i>, 1(4): 100052. (Corresponding author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zhou, Z., <b>Gong, Q.*</b>, Qi, Z., &amp; Sun, L. (2019). ML-Process Canvas: A Design Tool to Support the UX Design of Machine Learning-Empowered Products. <i>Extended Abstracts of the 2019 CHI Conference on Human Factors in Computing Systems – CHI EA ’19</i>, 1–6. (CCF-A, top conference, second author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Li, C., <b>Gong, Q.*</b>, Yu, Z., Zhai, Y. (2025). An Imbalanced Fault Diagnosis Framework Based on Subdomain Adaptation Mechanism of Dual-Branch Network. In <i>2025 IEEE International Conference on Systems, Man, and Cybernetics (SMC)</i>, Vienna, Austria, pp. 5197–5202. (CCF-C, second author)
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., Hou, Z., Chai, Y., Kong, W., Zhao, B., <b>Gong, Q.*</b>, &amp; Fang, Q. (2025). Lighting experience design in virtual environments. <i>Journal of Zhejiang University (Engineering Science)</i>, 59(10).
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., Zhao, Z., Yang, Y., Zhou, J., Zhang, X., Li, X., <b>Gong, Q.*</b>, Wu, Y., &amp; Zheng, Z. (2024). Tangible Interaction Design in Music Intervention for Chinese Children with Developmental Dyslexia. <i>International Journal of Human–Computer Interaction</i>, 41(8), 4851–4872.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zhou, Z., Sun, L., Zhang, Y., Liu, X., &amp; <b>Gong, Q.*</b> (2020). ML Lifecycle Canvas: Designing Machine Learning–Empowered UX with Material Lifecycle Thinking. <i>Human–Computer Interaction</i>, 35(5–6), 362–386.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <h2>PATENTS </h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Foldable 3D information acquisition device. Invention patent, CN115002439B. Granted: June 2, 2023.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Method for analyzing the importance of product definition based on user needs and user motivations. Invention patent, CN115600380A. Published: January 13, 2023.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Handheld haptic feedback device and weight simulation method for virtual reality. Invention patent, CN118012260A. Publication date: May 10, 2024.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>

                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>


    </div>
</template>

<script>

    import download from "downloadjs";
    export default {
        name: "CV",
        methods: {
            download() {
                download("/GONGQing_resume.pdf");
            },
        }
    }

</script>

<style scoped>
    .Chinese{
        display:none;
    }
    .bullet{
        margin-left: 20px;
    }
    .bulletlist{
        margin-top: 10px;
        line-height: 25px;
        font-size: 15px;
        font-weight: 100;
        color: #333;

    }
    h2{
        font-size:24px;
        font-weight: 100;
        letter-spacing:2px;
        color: #333333;
    }
    .section-heading{
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 24px;
    }
    .section-heading h2{
        margin: 0;
    }
    .detailBTN{
        margin-top: 2px;
        cursor:pointer;
        width: 150px;
        height: 50px;
        background-color: #333;
        color: #fff;
        border: none;
    }
    .detailBTN:hover{
        opacity: 80%;
    }
    .content-text{
        margin-left: 50px;
        margin-top: -25px;
    }
    .content{
        margin-top: 50px;
    }
    .grid-content {
        min-height: 36px;
        border:none;

    }
    .photo img{
        width: 100%;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
        cursor:pointer;
       text-decoration: none;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>
